import { t } from 'i18next';
import { isEmpty } from "lodash";
import { Trans } from "react-i18next";
import styled from "styled-components";
import { ReactComponent as RightArrowIcon } from "../../icons/arrow.right.svg";
import { FAN_BUDDY_MBTI } from "../../utils/FanBuddyHelper";
import { useColorMode } from '@chakra-ui/react';

const Box = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 18px 20px;
  border-radius: 14px;
  box-shadow: ${props => props.colorMode === 'dark' ? 'inset 0px 0px 1px 1px rgba(255,255,255,0.04)' : ' inset 0px 0px 1px 1px rgba(0,0,0,0.04)'};
  background: ${props =>
    props.colorMode === 'dark' ?
    `linear-gradient(158deg, rgba(50, 50, 50, 0.63) 0%, rgba(50, 50, 50, 0.90) 5.61%, rgba(50, 50, 50, 0.27) 19.79%, rgba(50, 50, 50, 0.90) 36%, rgba(50, 50, 50, 0.43) 70%, rgba(50, 50, 50, 0.90) 100%), linear-gradient(205deg, rgba(${props.backgroundPrimaryColor}) 0%, rgba(50, 50, 50, 0.00) 41.2%, rgba(${props.backgroundSecondaryColor}) 82.4%)`
    :
    `linear-gradient(158deg, rgba(255, 255, 255, 0.63) 0%, rgba(255, 255, 255, 0.90) 5.61%, rgba(255, 255, 255, 0.27) 19.79%, rgba(255, 255, 255, 0.90) 36%, rgba(255, 255, 255, 0.43) 70%, rgba(255, 255, 255, 0.90) 100%), linear-gradient(205deg, rgba(${props.backgroundPrimaryColor}) 0%, rgba(255, 255, 255, 0.00) 41.2%, rgba(${props.backgroundSecondaryColor}) 82.4%)`
  }
`

const MBTITitle = styled.div`
  font-size: 15px;
  font-weight: 700;
  line-height: 18px;
  background: ${props => `linear-gradient(90deg, rgba(${props.textPrimaryColor},1) 0%, rgba(${props.textSecondaryColor},1) 100%)`};
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
	word-break: keep-all;
`

// const MutualMembers = styled.span`
//   font-size: 12px;
//   font-weight: 400;
//   line-height: 15px;
//   text-align: left;
//   color: ${LightColors.textmainlv4}
// `


const ProfileMBTIBox = ({ mbti, mutualMembers, isMine = false, onClickBox, ...props }) => {
  const { colorMode } = useColorMode();
  const fanBuddyMBTI = FAN_BUDDY_MBTI[mbti];

  return (
    <Box
      backgroundPrimaryColor={fanBuddyMBTI.backgroundColor.primary}
      backgroundSecondaryColor={fanBuddyMBTI.backgroundColor.secondary}
      colorMode={colorMode}
      onClick={() => onClickBox()}
      {...props}
    >
      <div className="flex flex-col gap-[2px]">
        <MBTITitle
          textPrimaryColor={fanBuddyMBTI.textColor.primary}
          textSecondaryColor={fanBuddyMBTI.textColor.secondary}
        >
          {fanBuddyMBTI.name}
        </MBTITitle>
        {(
          <div className="flex flex-row gap-[2px] items-center">
            <img src="/assets/icons/like.shape.shine.png" alt="mutual" width={20} height={20} className="ml-[-2px]"/>
            <div className="text-[12px] font-normal leading-[15px] text-left text-main-light-4 dark:text-main-dark-4">
              {isEmpty(mutualMembers) ? (
                <>{t('ProfileMBTIBox.emptyMutualArtist')}</>
              ) : mutualMembers.length <= 2 ? (
                <Trans
                  i18nKey="UserProfileSearchPage.mutualBias"
                  components={{ bold: <strong /> }}
                  values={{ members: mutualMembers?.map((member) => member.name)?.join(', ') }}
                />
              ) : (
                <Trans
                  i18nKey="UserProfileSearchPage.mutualBiasMore"
                  components={{ bold: <strong /> }}
                  values={{
                    members: `${mutualMembers
                      ?.map((member) => member.name)
                      ?.slice(0, 2)
                      .join(', ')}`,
                    count: mutualMembers?.length - 2
                  }}
                />
              )}
            </div>
          </div>
        )}
      </div>
      <RightArrowIcon width={20} height={20} className="fill-black/40 dark:fill-white/40" />
    </Box>
  );
}

export default ProfileMBTIBox;
